import { Injectable, Inject, LOCALE_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocaleService {
	constructor(@Inject(LOCALE_ID) private locale: string) {}

	/**
	 * This is to fix a ng02100 error we were getting when testing with Durka. It seems like
	 * it didn't have the locale set and that was messing up the date pipe so this is to
	 * give a fallback locale if there isn't one set.
	 */
	getLocale(): string {
		let myLocale = this.locale;
		if (!myLocale) {
			myLocale = 'en-US';
		}

		return myLocale;
	}
}
